export function mergeHeaders(...headersArgs) {
    const mergedHeaders = new Headers();
    headersArgs.forEach((headers) => {
        const loopHeaders = headers instanceof Headers ? headers : new Headers(headers);
        loopHeaders.forEach((value, key) => {
            mergedHeaders.set(key, value);
        });
    });
    return mergedHeaders;
}
//# sourceMappingURL=mergeHeaders.js.map